'use client';

import { PieChart } from '@mui/x-charts/PieChart';

import { DEFAULT_CHART_COLORS } from './chartColors';
import styles from './DonutChart.module.scss';

export type DonutChartDatum = {
  id?: string | number;
  label: string;
  value: number;
  color?: string;
};

type DonutChartProps = {
  data: DonutChartDatum[];
  centerLabel?: string;
  centerSubLabel?: string;
  height?: number;
  className?: string;
  ariaLabel?: string;
};

export function DonutChart({
  data,
  centerLabel,
  centerSubLabel,
  height = 240,
  className,
  ariaLabel,
}: DonutChartProps) {
  const chartData = data.map((item, index) => ({
    id: item.id ?? item.label,
    label: item.label,
    value: item.value,
    color:
      item.color ?? DEFAULT_CHART_COLORS[index % DEFAULT_CHART_COLORS.length],
  }));

  return (
    <div className={[styles.donutChart, className].filter(Boolean).join(' ')}>
      <PieChart
        aria-label={ariaLabel}
        height={height}
        margin={{ top: 8, right: 8, bottom: 8, left: 8 }}
        hideLegend
        slotProps={{
          pieArc: {
            stroke: 'none',
            strokeWidth: 0,
            strokeLinejoin: undefined,
          },
        }}
        sx={{
          '& .MuiPieArc-root, & path[class*="MuiPieArc-root"]': {
            stroke: 'none !important',
            strokeWidth: '0 !important',
            strokeLinejoin: 'unset !important',
          },
        }}
        series={[
          {
            data: chartData,
            innerRadius: 58,
            outerRadius: 88,
            paddingAngle: 1,
            cornerRadius: 4,
          },
        ]}
      />
      {centerLabel || centerSubLabel ? (
        <div className={styles.donutChart__center} aria-hidden="true">
          {centerLabel ? (
            <span className={styles.donutChart__centerLabel}>
              {centerLabel}
            </span>
          ) : null}
          {centerSubLabel ? (
            <span className={styles.donutChart__centerSubLabel}>
              {centerSubLabel}
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
